<template>
  <div>
    <self-back :pageHeaderList="[{'name':'付款公司配置'}]"></self-back>
    <div class="content" v-loading='loading'>
      <button class="addaccountButton" @click="addaccountEvent">+ 添加公司</button>
      <el-table class="table" :header-cell-style="{background:'#f5f7fa'}" :data="accountList" :max-height="tableMaxHeight" border>
        <el-table-column prop="company_name" label="线下付款公司" align='center' width="200">
        </el-table-column>
        <el-table-column align='center' label="线下补款比例">
          <template slot-scope="scope">
            {{ formatRebate(scope.row.rebate) }}
          </template>
        </el-table-column>
        <el-table-column align='center' label="默认">
          <template slot-scope="scope">
            <i class="el-icon-circle-check" v-if="scope.row.is_default==1" style="color: #5c7bfe;font-size: 16px;"></i>
          </template>
        </el-table-column>
        <el-table-column align='center' label="线下成本发票申请记录">
          <template slot-scope="scope">
            <p v-for="(item,index) in scope.row.invoice_arr" :key="index+'invoice_arr'">{{item}}</p>
          </template>
        </el-table-column>
        <el-table-column align='center' label="操作">
          <template slot-scope="scope">
            <button @click="setofflineCostInvoice(scope.row)">线下成本发票申请</button>
            <button @click="modifyaccountEvent(scope.row)">修改</button>
            <button v-if="scope.row.del_enable==1" style="background:#FC726D" @click="deleteaccountFlagEvent(scope.row)">删除</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paginationBox" style="height: 30px;">
        <el-pagination small background :current-page="page" :page-size="page_size" @current-change="handleCurrentChange" layout="total, prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 添加账号 -->
    <el-dialog :title="isEdit?'修改公司':'添加公司'" :visible.sync="addaccountFlag" width="30%" :close-on-click-modal='false' center>
      <div class="dialogBox">
        <div class="dialogitem">
          <label><em>*</em>公司名称：</label>
          <el-input :disabled="isEdit?true:false" placeholder="请输入公司名称" style="width:67%" v-model.trim="accountName" size='small' clearable>
          </el-input>
        </div>
        <div class="dialogitem">
          <label><em>*</em>线下补款比例：</label>
          <el-input placeholder="请输入线下补款比例（最多4位小数）" style="width:67%" v-model.trim="companyName" @input="formatRebateInput" size='small' clearable>
          </el-input>
        </div>
        <div class="dialogitem">
          <label>设为默认：</label>
          <el-checkbox v-model="isDefault">是</el-checkbox>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAddaccount" size="mini">取 消</el-button>
        <el-button type="primary" @click="addaccountYes" size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 线下成本发票申请 -->
    <el-dialog title="线下成本发票申请" :visible.sync="offlineCostInvoiceFlag" width="500px" :close-on-click-modal='false'>
      <div class="offlineCostInvoicebox">
        <div class="flex-between" style="margin-top:-15px;margin-bottom:15px">
          <div class="dialogitem flex">
            <label>公司名称：</label>
            <div class="input">{{offlineCostInvoiceInfo.company_name}}</div>
          </div>
        </div>
        <div class="dialogitem">
          <label><em>*</em>开票日期：</label>
          <el-date-picker class="input" v-model="cost_invoice_date" type="date" size="small" value-format="yyyy-MM-dd" placeholder="选择时间"></el-date-picker>
        </div>
        <div class="dialogitem">
          <label><em>*</em>所属月份：</label>
          <el-select multiple class="input" style="width:69%" v-model="month_arr" size='small' filterable placeholder="选择月份">
            <el-option v-for="(item,index) in allMontList" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="dialogitem flex" style="width:100%">
          <label>申请说明：</label>
          <el-input placeholder="请输入申请说明" style="width:70%" type='textarea' v-model.trim="apply_note" size='small' clearable></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelofflineCostInvoice" size="mini">取 消</el-button>
        <el-button type="primary" @click="offlineCostInvoiceSubmit" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      addaccountFlag: false,
      deleteaccountFlag: false,
      accountList: [],
      accountName: '',
      page: 1,
      page_size: 20,
      total: 0,
      loading: false,
      isEdit: false,
      vebateId: '',
      companyName: '',
      isDefault: false,
      offlineCostInvoiceFlag: false,
      offlineCostInvoiceInfo: {},
      cost_invoice_date: '',
      apply_note: '',
      month_arr: [],
      allMontList: []
    }
  },
  computed: {
    // 计算表格最大高度，确保分页控件可见
    tableMaxHeight() {
      // Header(60) + self-back(50) + padding(30) + button(30) + table-margin(15) + pagination(40) + pagination-margin(15) + footer(70) + footer-margin(10) = 320px
      return window.innerHeight - 260;
    }
  },
  created () {
    this.getAllMontListEvent()
    this.accountsListEvent(1)
  },
  methods: {
    formatRebate (value) {
      if (value === '' || value === null || typeof value === 'undefined') {
        return ''
      }
      return Number(value).toFixed(4)
    },
    formatRebateInput (value) {
      let rebate = String(value).replace(/[^\d.]/g, '')
      const decimalIndex = rebate.indexOf('.')
      if (decimalIndex !== -1) {
        rebate = rebate.slice(0, decimalIndex + 1) + rebate.slice(decimalIndex + 1).replace(/\./g, '').slice(0, 4)
      }
      this.companyName = rebate
    },
    setofflineCostInvoice (data) {//设置成本开票日期
      this.offlineCostInvoiceFlag = true;
      this.offlineCostInvoiceInfo = data;
    },
    cancelofflineCostInvoice () {
      this.offlineCostInvoiceInfo = {}
      this.offlineCostInvoiceFlag = false
      this.month_arr = []
      this.apply_note = ''
      this.cost_invoice_date = ''
    },
    offlineCostInvoiceSubmit () {
      if (this.cost_invoice_date == '' || !this.cost_invoice_date) {
        this.$message({
          message: '请选择开票日期',
          type: 'fail'
        })
        return
      }
      if (!this.month_arr || this.month_arr.length == 0) {
        this.$message({
          message: '请选择所属月份',
          type: 'fail'
        })
        return
      }
      this.$loading(this.$loadingConfig)
      this.$axios.post(this.URL.BASEURL + this.URL.setofflineCostInvoice, {
        company_name: this.offlineCostInvoiceInfo.company_name,
        month_arr: this.month_arr,
        invoice_date: this.cost_invoice_date,
        apply_note: this.apply_note
      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          this.accountsListEvent(this.page)
          this.cancelofflineCostInvoice()
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    addaccountEvent () {//点击添加账号按钮
      this.addaccountFlag = true;
      this.isEdit = false;
    },
    deleteaccountFlagEvent (data) {//删除账号
      this.$confirm('确定要删除该配置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.URL.BASEURL + this.URL.companyDel, {
          id: data.id,
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.accountsListEvent(this.page)
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
        })
      }).catch(() => {
      });
    },
    handleCurrentChange (val) {
      this.accountsListEvent(val)
    },
    accountsListEvent (page) {
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.companyList, {
        params: {
          page: page,
          page_size: this.page_size,
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.accountList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    addaccountYes () {//添加账号
      if (this.accountName == '') {
        this.$message({
          message: '请输入公司名称',
          type: 'fail'
        })
        return
      }
      if (this.companyName == '') {
        this.$message({
          message: '请输入线下补款比例',
          type: 'fail'
        })
        return
      }
      if (!/^\d+(\.\d{1,4})?$/.test(this.companyName)) {
        this.$message({
          message: '线下补款比例最多支持4位小数',
          type: 'fail'
        })
        return
      }
      if (this.isEdit) {//编辑
        this.$axios.post(this.URL.BASEURL + this.URL.companyEdit, {
          id: this.vebateId,
          company_name: this.accountName,
          rebate: this.companyName,
          is_default: this.isDefault ? 1 : 0
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.accountsListEvent(this.page)
            this.cancelAddaccount()
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
        })
      } else {
        this.$axios.post(this.URL.BASEURL + this.URL.companyAdd, {
          company_name: this.accountName,
          rebate: this.companyName,
          is_default: this.isDefault ? 1 : 0
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.accountsListEvent(this.page)
            this.cancelAddaccount()
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
        })
      }
    },
    cancelAddaccount () {//取消添加账号
      this.addaccountFlag = false;
      this.accountName = '';
      this.companyName = '';
      this.isDefault = false;
    },
    modifyaccountEvent (data) {//修改账号
      this.accountName = data.company_name;
      this.vebateId = data.id;
      this.companyName = data.rebate;
      this.isDefault = data.is_default == 1 ? true : false;
      this.isEdit = true;
      this.addaccountFlag = true;
    },
    getAllMontListEvent () {
      this.$axios.get(this.URL.BASEURL + this.URL.getAllMontList, {
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          var data = res.rst;
          this.allMontList = data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
  },
  watch: {

  }
}
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
  padding: 15px 15px 15px;
  // display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-height: calc(100vh - 140px);
  .addaccountButton {
    height: 30px;
    background: #5b7bfe;
    border-radius: 4px;
    color: #ffffff;
    font-size: 13px;
    border: none;
    padding: 0 10px;
    flex-shrink: 0;
  }
  .table {
    margin-top: 15px;
    flex: 1;
    min-height: 0;
    button {
      min-width: 48px;
      height: 22px;
      background: #5b7bfe;
      border-radius: 4px;
      color: #ffffff;
      font-size: 12px;
      border: none;
      padding: 0 6px;
    }
  }
  .paginationBox {
    flex-shrink: 0;
    margin-top: 15px;
    padding-bottom: 0;
  }
}
.dialogitem {
  margin-bottom: 20px;
  &:last-of-type {
    margin-bottom: 0;
  }
  label {
    display: inline-block;
    width: 120px;
    color: #202652;
    font-size: 14px;
    line-height: 20px;
    em {
      color: red;
    }
  }
}
.offlineCostInvoicebox {
  .dialogitem {
    label {
      width: 80px;
    }
  }
}
.flex-between {
  display: flex;
  justify-content: space-between;
}
.flex {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/disposeAdmin/companyConfigure.vue